import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar } from "webapp/components";
import { PPUConsentScreen } from "webapp/components/Partner/CIBC/PPUConsentScreen/Index";
import FIMCMemberInformationForm from "webapp/components/Partner/FIMC/FIMCMemberInformationForm/FIMCMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function FIMCMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [memberInfo, setMemberInfo] = useState(null);
  const [showPPUConsent, setShowPPUConsent] = useState(false);
  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("FIMC.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserNext = () => {
    devLog("onUserNext");
    if (memberInfo?.PPUReason === "EXPIRED") {
      devLog("memberInfo.accountRef", memberInfo?.accountRef);
      props.context.setState(
        {
          MemberNumber: memberInfo?.memberNumber,
          accountRef: memberInfo?.accountRef,
          contactRef: memberInfo?.contactRef,
          vip: memberInfo?.vip == "true",
          // webAppState: AppState.ConfirmVehicle,
        },
        () => {
          // Ensure state is saved before showing PPU consent screen
          props.context.saveWebAppState(props.context);
          setShowPPUConsent(true);
        },
      );
      return;
    }
    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
    if (memberInfo?.memberNumber) {
      devLog("onMemberNext", memberInfo?.memberNumber);
      props.context.setState(
        {
          MemberNumber: memberInfo?.memberNumber,
          accountRef: memberInfo?.accountRef,
          contactRef: memberInfo?.contactRef,
          vip: memberInfo?.vip == "true",
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      props.context.setState(
        {
          MemberNumber: null,
          webAppState: AppState.MemberSearch,
        },
        () => {},
      );
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  const onMemberInfo = (info) => {
    devLog("onMemberInfo", info);
    setMemberInfo(info);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("FIMC.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <FIMCMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onMemberInfo={onMemberInfo}
        />
      </div>

      {showPPUConsent && (
        <PPUConsentScreen
          onUserBack={props.backButtonFunc}
          onUserSubmit={onUserNext}
          currState={props.currState}
          context={props.context}
          PPUReason={memberInfo?.PPUReason}
        />
      )}

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
    </>
  );
}

export default FIMCMemberInformation;
